import React from 'react';
import { Wrapper, InfoWrapper, ButtonsWrapper } from './CompanyFooter.styles';
import {
	colors,
	ApButtonIcon,
	ApButtonSecondary,
	ApIcon,
} from '@alixpartners/ui-components';

export const CompanyFooter = ({
	onReset,
	onExpand,
	percentage = 0,
	canEdit,
}) => {
	const expandAll = () => {
		onExpand();
	};
	const collapseAll = () => {
		onExpand(false);
	};
	return (
		<Wrapper>
			<ButtonsWrapper>
				<ApButtonIcon iconName="unfold_more" onClick={expandAll} />
				<ApButtonIcon iconName="unfold_less" onClick={collapseAll} />
				<ApButtonSecondary onClick={onReset} disabled={canEdit}>
					Reset
				</ApButtonSecondary>
			</ButtonsWrapper>
			<InfoWrapper>
				<span>{percentage}% of spend mapped</span>
				{percentage === 100 && (
					<ApIcon iconName="done_all" iconColor={colors.green1} />
				)}
			</InfoWrapper>
		</Wrapper>
	);
};

export default CompanyFooter;
